import { CreateMetaSiteHandlerRequest, CreateMetaSiteHandlerResponse } from 'server/handlers/createMetaSite';
import { httpUtils } from 'utils/http';
import { ENDPOINTS } from 'config/endpoints';
import { UploadSiteMediaHandlerRequest, UploadSiteMediaHandlerResponse } from 'server/handlers/uploadSiteMedia';
import { GenerateMockupsHandlerRequest, GenerateMockupsHandlerResponse } from 'server/handlers/generateMockups';
import {
  AttachSiteTemplateHandlerRequest,
  AttachSiteTemplateHandlerResponse,
} from 'server/handlers/attachSiteTemplate';
import { InstallSiteAppsHandlerRequest, InstallSiteAppsHandlerResponse } from 'server/handlers/installSiteApps';
import { ResetStoreHandlerRequest, ResetStoreHandlerResponse } from 'server/handlers/resetStore';
import { GetSiteUrlsHandlerRequest, GetSiteUrlsHandlerResponse } from 'server/handlers/getSiteUrls';
import { AddStoreProductsHandlerRequest, AddStoreProductsHandlerResponse } from 'server/handlers/addStoreProducts';
import { GetProductsCountHandlerRequest, GetProductsCountHandlerResponse } from 'server/handlers/getProductsCount';
import {
  updateSiteSettings as updateSiteSettingsHttp,
  suggestStoreName as suggestStoreNameHttp,
  publishSite as publishSiteHttp,
} from '@wix/ambassador-gg-store-setup-v1-store-setup-service/http';
import {
  UpdateSiteSettingsRequest,
  SuggestStoreNameRequest,
} from '@wix/ambassador-gg-store-setup-v1-store-setup-service/types';
import {
  InjectComponentCoreHandlerRequest,
  InjectComponentCoreHandlerResponse,
} from 'server/handlers/injectComponentCore';

const createMetaSite = async (params: CreateMetaSiteHandlerRequest) => {
  const response = await httpUtils.client.post<CreateMetaSiteHandlerResponse>(ENDPOINTS.CREATE_META_SITE, params);
  return response.data;
};

const uploadSiteMedia = async (params: UploadSiteMediaHandlerRequest) => {
  const data = new FormData();
  data.append('media', params.media);
  const response = await httpUtils.client.post<UploadSiteMediaHandlerResponse>(ENDPOINTS.UPLOAD_SITE_MEDIA, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

const generateMockups = async (params: GenerateMockupsHandlerRequest) => {
  const response = await httpUtils.client.post<GenerateMockupsHandlerResponse>(ENDPOINTS.GENERATE_MOCKUPS, params);
  return response.data;
};

const attachSiteTemplate = async (params: AttachSiteTemplateHandlerRequest) => {
  const response = await httpUtils.client.post<AttachSiteTemplateHandlerResponse>(
    ENDPOINTS.ATTACH_SITE_TEMPLATE,
    params,
  );
  return response.data;
};

const installSiteApps = async (params: InstallSiteAppsHandlerRequest) => {
  const response = await httpUtils.client.post<InstallSiteAppsHandlerResponse>(ENDPOINTS.INSTALL_SITE_APPS, params);
  return response.data;
};

const publishSite = async () => {
  const response = await httpUtils.ambassador.request(publishSiteHttp({}));
  return response.data;
};

const resetStore = async (params: ResetStoreHandlerRequest) => {
  const response = await httpUtils.client.post<ResetStoreHandlerResponse>(ENDPOINTS.RESET_STORE, params);
  return response.data;
};

const getSiteUrls = async (params: GetSiteUrlsHandlerRequest) => {
  const response = await httpUtils.client.post<GetSiteUrlsHandlerResponse>(ENDPOINTS.GET_SITE_URLS, params);
  return response.data;
};

const addStoreProducts = async (params: AddStoreProductsHandlerRequest) => {
  const response = await httpUtils.client.post<AddStoreProductsHandlerResponse>(ENDPOINTS.ADD_STORE_PRODUCTS, params);
  return response.data;
};

const updateSiteSettings = async (params: UpdateSiteSettingsRequest) => {
  const response = await httpUtils.ambassador.request(updateSiteSettingsHttp(params));
  return response.data;
};

const injectComponentCore = async (params: InjectComponentCoreHandlerRequest) => {
  const response = await httpUtils.client.post<InjectComponentCoreHandlerResponse>(
    ENDPOINTS.INJECT_COMPONENT_CORE,
    params,
  );
  return response.data;
};

const suggestSiteNames = async (params: SuggestStoreNameRequest) => {
  const response = await httpUtils.ambassador.request(suggestStoreNameHttp(params));
  return response.data;
};

const getProductsCount = async (params: GetProductsCountHandlerRequest) => {
  const response = await httpUtils.client.post<GetProductsCountHandlerResponse>(ENDPOINTS.GET_PRODUCTS_COUNT, params);
  return response.data;
};

export const endpoints = {
  createMetaSite,
  uploadSiteMedia,
  generateMockups,
  attachSiteTemplate,
  installSiteApps,
  publishSite,
  resetStore,
  getSiteUrls,
  addStoreProducts,
  updateSiteSettings,
  injectComponentCore,
  suggestSiteNames,
  getProductsCount,
};
